export interface BeachDestination {
    slug: string;
    name: string;
    badge: string;
    image: string;
    description: string;
    tags: { icon: string; label: string }[];
    href: string;
}

export const beachDestinations: BeachDestination[] = [
    {
        slug: "tolou",
        name: "Tolou",
        badge: "Incontournable",
        image: "/images/ivoirexperience/the-place-to-be/galleries/tolou/legacy.png",
        description:
            "Tolou Plage – Une parenthèse de rêve au bout du monde. Sur la route reliant Tabou à Grand-Béréby, découvrez Tolou, un authentique village Kroumen où la nature règne en maître.",
        tags: [
            { icon: "🌿", label: "Village Kroumen" },
            { icon: "🏖️", label: "Plage" },
        ],
        href: "/ivoirexperience/the-place-to-be/tolou",
    },
    {
        slug: "monogaga",
        name: "Monogaga",
        badge: "Incontournable",
        image: "/images/ivoirexperience/the-place-to-be/galleries/monogaga/legacy.png",
        description:
            "Plage de Monogaga – L'évasion au cœur d'un paradis sauvage. Nichée sur la côte ouest ivoirienne, entre San Pedro et Sassandra, une destination d'exception où la nature s'exprime dans toute sa splendeur.",
        tags: [
            { icon: "🌅", label: "Couchers de soleil" },
            { icon: "🏄", label: "Surf" },
        ],
        href: "/ivoirexperience/the-place-to-be/monogaga",
    },
    {
        slug: "assinie",
        name: "Assinie",
        badge: "Incontournable",
        image: "/images/ivoirexperience/the-place-to-be/assinie.jpg",
        description:
            "Assinie – Le joyau balnéaire de la Côte d'Ivoire. Envie d'évasion, de détente et de paysages de carte postale ? Assinie séduit par ses plages de sable blanc et ses eaux cristallines.",
        tags: [
            { icon: "🏖️", label: "Plage" },
            { icon: "🌊", label: "Océan & lagune" },
        ],
        href: "/ivoirexperience/the-place-to-be/assinie",
    },
    {
        slug: "sassandra",
        name: "Sassandra",
        badge: "Incontournable",
        image: "/images/ivoirexperience/the-place-to-be/sassandra.jpg",
        description:
            "Sassandra – Port historique et plages atlantiques au cœur du Bas-Sassandra. Entre estuaire, cocoteraies et océan, une escale authentique entre San-Pédro et Fresco.",
        tags: [
            { icon: "⚓", label: "Port de pêche" },
            { icon: "🏖️", label: "Plage" },
        ],
        href: "/ivoirexperience/the-place-to-be/sassandra",
    },
    {
        slug: "grand-bereby",
        name: "Grand-Béréby",
        badge: "Incontournable",
        image: "/images/ivoirexperience/the-place-to-be/galleries/grand-bereby/legacy.png",
        description:
            "Grand-Béréby – L'élégance naturelle du littoral ivoirien. Entre océan, lagunes et forêts tropicales, une station côtière de charme qui invite à la détente et à l'aventure.",
        tags: [
            { icon: "🌿", label: "Nature" },
            { icon: "🐢", label: "Faune marine" },
        ],
        href: "/ivoirexperience/the-place-to-be/grand-bereby",
    },
    {
        slug: "mani-bereby",
        name: "Mani-Béréby",
        badge: "Incontournable",
        image: "/images/ivoirexperience/the-place-to-be/galleries/mani-bereby/legacy.png",
        description:
            "Mani-Béréby – Entre lagune, océan et nature préservée. Un village balnéaire authentique à proximité de San Pedro, porte d'entrée vers les îles Ehotilé.",
        tags: [
            { icon: "⛵", label: "Pirogue" },
            { icon: "🌿", label: "Nature" },
        ],
        href: "/ivoirexperience/the-place-to-be/mani-bereby",
    },
    {
        slug: "grand-lahou",
        name: "Grand-Lahou",
        badge: "Incontournable",
        image: "/images/ivoirexperience/the-place-to-be/galleries/grand-lahou/legacy.png",
        description:
            "Plage de Grand-Lahou – Là où la lagune rencontre l'océan. À l'embouchure du fleuve Bandama, un décor unique entre eaux lagunaires et Atlantique.",
        tags: [
            { icon: "🌊", label: "Lagune & océan" },
            { icon: "🚣", label: "Pirogue" },
        ],
        href: "/ivoirexperience/the-place-to-be/grand-lahou",
    },
    {
        slug: "dagbego",
        name: "Dagbego",
        badge: "À découvrir",
        image: "/images/ivoirexperience/the-place-to-be/galleries/dagbego/legacy.png",
        description:
            "Dagbego – Un joyau du littoral lagunaire ivoirien, entre eaux calmes, végétation luxuriante et authenticité des villages côtiers.",
        tags: [
            { icon: "🌿", label: "Lagune" },
            { icon: "🏖️", label: "Plage" },
        ],
        href: "/ivoirexperience/the-place-to-be/dagbego",
    },
    {
        slug: "baie-des-milliardaires",
        name: "Baie des Milliardaires",
        badge: "À découvrir",
        image: "/images/ivoirexperience/the-place-to-be/galleries/baie-des-milliardaires/legacy.png",
        description:
            "Baie des Milliardaires – Un littoral d'exception aux portes d'Assinie, entre cocotiers, sable fin et eaux turquoise dans un cadre préservé.",
        tags: [
            { icon: "🏖️", label: "Plage chic" },
            { icon: "☀️", label: "Ensoleillée" },
        ],
        href: "/ivoirexperience/the-place-to-be/baie-des-milliardaires",
    },
    {
        slug: "fresco",
        name: "Fresco",
        badge: "À découvrir",
        image: "/images/ivoirexperience/the-place-to-be/galleries/fresco/legacy.png",
        description:
            "Fresco – Une perle de la côte ouest ivoirienne, réputée pour ses plages sauvages, son ambiance de village de pêcheurs et ses paysages côtiers préservés.",
        tags: [
            { icon: "🎣", label: "Pêche" },
            { icon: "🌅", label: "Couchers de soleil" },
        ],
        href: "/ivoirexperience/the-place-to-be/fresco",
    },
    {
        slug: "kosso",
        name: "Kosso",
        badge: "À découvrir",
        image: "/images/ivoirexperience/the-place-to-be/galleries/kosso/legacy.png",
        description:
            "Kosso – Un littoral préservé du sud-ouest ivoirien, entre lagune, forêt tropicale et plages encore méconnues des voyageurs.",
        tags: [
            { icon: "🌿", label: "Sauvage" },
            { icon: "🏖️", label: "Plage" },
        ],
        href: "/ivoirexperience/the-place-to-be/kosso",
    },
    {
        slug: "tabou",
        name: "Tabou",
        badge: "À découvrir",
        image: "/images/ivoirexperience/the-place-to-be/galleries/tabou/legacy.png",
        description:
            "Tabou – Porte d'entrée du littoral extrême sud-ouest, commune dynamique et point de départ vers les plus belles plages de la région, dont Tolou.",
        tags: [
            { icon: "🗺️", label: "Sud-ouest" },
            { icon: "🏖️", label: "Littoral" },
        ],
        href: "/ivoirexperience/the-place-to-be/tabou",
    },
    {
        slug: "taki",
        name: "Taki",
        badge: "À découvrir",
        image: "/images/ivoirexperience/the-place-to-be/galleries/taki/legacy.png",
        description:
            "Taki – Un havre de paix sur le littoral ivoirien, entre lagune paisible, cocotiers et eaux calmes propices à la détente et à la contemplation.",
        tags: [
            { icon: "🌊", label: "Lagune" },
            { icon: "🌴", label: "Tropical" },
        ],
        href: "/ivoirexperience/the-place-to-be/taki",
    },
];
